/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../graphql.generated'

const defaultOptions = {} as const
export type GetPatientHistoryTypesQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetPatientHistoryTypesQuery = {
  __typename?: 'Query'
  patient: {
    __typename?: 'Patient'
    program?: { __typename?: 'Program'; patientHistoryTypes?: Array<string> | null } | null
  }
}

export const GetPatientHistoryTypesDocument = gql`
  query getPatientHistoryTypes($uid: ID!) {
    patient(uid: $uid) {
      program {
        patientHistoryTypes(uid: $uid)
      }
    }
  }
`

/**
 * __useGetPatientHistoryTypesQuery__
 *
 * To run a query within a React component, call `useGetPatientHistoryTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientHistoryTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientHistoryTypesQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetPatientHistoryTypesQuery(
  baseOptions: Apollo.QueryHookOptions<GetPatientHistoryTypesQuery, GetPatientHistoryTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPatientHistoryTypesQuery, GetPatientHistoryTypesQueryVariables>(
    GetPatientHistoryTypesDocument,
    options
  )
}
export function useGetPatientHistoryTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPatientHistoryTypesQuery, GetPatientHistoryTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPatientHistoryTypesQuery, GetPatientHistoryTypesQueryVariables>(
    GetPatientHistoryTypesDocument,
    options
  )
}
export type GetPatientHistoryTypesQueryHookResult = ReturnType<typeof useGetPatientHistoryTypesQuery>
export type GetPatientHistoryTypesLazyQueryHookResult = ReturnType<typeof useGetPatientHistoryTypesLazyQuery>
export type GetPatientHistoryTypesQueryResult = Apollo.QueryResult<
  GetPatientHistoryTypesQuery,
  GetPatientHistoryTypesQueryVariables
>
